import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('produtos/itens/subitens/precos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.PRODUTOS.PRODPRECOSPESQUISA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('produtos/itens/subitens/precos/novoatualiza',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.PRODUTOS.PRODNOVOATUALIZA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const subitemprecoselecionado = (evento = {}) => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.SUBITEMPRECOSELECIONADO,
        payload: evento
      })
    }
}